export default __webpack_public_path__ + "static/media/40214.63074f9c.jpg";